<div class="alert alert-info no-bg  mt-2" *ngIf="iData">
<form [formGroup] = "myForm"  class="form" enctype="multipart/form-data" id="make_payment_form">
    <div class="form-group row" [ngClass]="{error:f.country.errors && f.country.touched}">

            <div class="input-group col-sm-12">
              <div><h3 class="text-center">Select  Country for the curriculum you want <span class="px-2">
                    <app-country-flag *ngIf="iData" [countryImage]="iData.countryImage"></app-country-flag>
                </span></h3> </div>
              <div>
                <select class="form-control" id="icountry"  #myCountry formControlName="country"
                (change)='onCountryOptionsSelected(myCountry.value)'>
                    <option *ngFor="let country of countries" [value]="country.id" [selected]="iData.id==country.id">{{country.name}}</option>
                </select>

                </div>
            </div>
    </div>
</form>
</div>
